import { Flex } from "@chakra-ui/react"
import { ReactElement } from "react"
import { LabelWithSequenceModel, SimpleAssetModel } from "../../../../api-clients/product-api-v1"
import { pages } from "../../../../common/constants/constants"
import { handleDownloadClick } from "../../../../common/utils/common-utils"
import { ChakraNextLinkButton } from "../../../shared/ChakraNextLinkButton"
import DownloadButton from "../../../shared/DownloadButton/DownloadButton"

type LocalDataItemType = SimpleAssetModel & LabelWithSequenceModel

type Props = {
  data: SimpleAssetModel[] | LabelWithSequenceModel[]
  leftIcon?: ReactElement
  urlPrefix?: string
}

const SectionColumn = ({ data, leftIcon, urlPrefix }: Props) => {
  return (
    <Flex flexDirection="column" w="100%" gap="2" alignItems="flex-start">
      {data.map((item: LocalDataItemType) => {
        return item?.url ? (
          <DownloadButton
            key={item.name}
            iconSpacing="2.5"
            label={item.name}
            onClick={(e) => handleDownloadClick(e, item.url)}
          />
        ) : (
          <ChakraNextLinkButton
            key={item.name}
            label={item.name}
            leftIcon={leftIcon}
            iconSpacing="2.5"
            href={item?.url ? item.url : `/${pages.SEARCH}?${urlPrefix}=${item.key}`}
            target={item?.url ? "_blank" : "_self"}
          />
        )
      })}
    </Flex>
  )
}

export default SectionColumn
